/**
 * Data attributes and props to tell password managers (LastPass, 1Password, Bitwarden,
 * Dashlane, RoboForm, Keeper) to ignore form fields that are not login credentials.
 * Use on non-password inputs to reduce incorrect autofill prompts.
 */
export const PW_MANAGER_OFF = {
  'data-lpignore': 'true',
  'data-form-type': 'other',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-dashlane-ignore': 'true',
  'data-roboform-ignore': 'true',
  'data-keeper-ignore': 'true',
  autoComplete: 'off',
}

/** Use on react-select wrappers (MultiSelectSearch, SelectDropDown), not spread as top-level props. */
export const PW_MANAGER_SELECT_PROPS = {
  inputProps: PW_MANAGER_OFF,
}
